import { getRootsBBox } from '../../../../../lib';

const getViewBox = (roots, size, crop, gutters) => (crop ? getRootsBBox(roots, gutters) : `0 0 ${size} ${size}`);

/**
 * Returns a given variations it's view box according to config,
 * When cropping is specified,the variation viewbox will be cropped by roots dimensions.
 * Otherwise, It will use the variation created size.
 * @param {String} id - The variation id
 * @param {Root[]} roots - The variation roots
 * @param {Number} size - The variation size
 * @param {Object} config
 * @param {Boolean} config.crop - Whether to crop variation viewbox or not
 * @param {Number} config.gutters - The inner variation gutters, Apply only when crop is true.
 * @returns {[String, Function]}
 */
export const useVariationViewBox = (id, roots, size, { crop, gutters }) => {
    const viewBox = getViewBox(roots, size, crop, gutters);

    return [viewBox];
};
